import { render, staticRenderFns } from "./infl-footnote.vue?vue&type=template&id=f8ee09b2&"
import script from "./infl-footnote.vue?vue&type=script&lang=js&"
export * from "./infl-footnote.vue?vue&type=script&lang=js&"
import style0 from "./infl-footnote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ee09b2')) {
      api.createRecord('f8ee09b2', component.options)
    } else {
      api.reload('f8ee09b2', component.options)
    }
    module.hot.accept("./infl-footnote.vue?vue&type=template&id=f8ee09b2&", function () {
      api.rerender('f8ee09b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/infl-footnote.vue"
export default component.exports